import CircleIcon from '@mui/icons-material/Circle';
import { Stack, Tooltip, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import React, { useCallback, useContext, useMemo } from "react";
import { WorkspacesContext } from "../../contexts/WorkspacesContext";
import theme from "../../theme";
import { Dashboard, Workspace } from "../../types/files";

const useStyles = makeStyles((theme) => ({
    scoreIcon: {
        width: 12,
        height: 12,
    },
}));

const ThesisScore: React.FC<{
    dashboard?: Dashboard,
    workspace?: Workspace,
    disabled?: boolean,
    flags?: any,
}> = ({ dashboard, workspace, disabled, flags }) => {
    const classes = useStyles();
    const { workspaceScores } = useContext(WorkspacesContext);

    const score = useMemo(() =>
        workspaceScores?.find(ws => ws?.workspaceId === workspace?.id)?.scores?.find(wsScore => wsScore.dashboardId === dashboard?.id)?.score || 0
    , [dashboard?.id, workspace?.id, workspaceScores]);

    const fitnessTip = useCallback(() => {
        const points = Math.round(score || 0);

        switch (points) {
            case 4:
                return 'Strong thesis fit';
            case 3:
                return 'Good thesis fit';
            case 2:
                return 'Possible thesis fit';
            case 1:
            default:
                return 'No thesis fit';
        }
    }, [score]);

    const fitnessColor = useCallback((index: number) => {
        const points = Math.round(score || 0);

        if (index < points) {
            if (disabled) {
                if (points >= 1)
                    return theme.colors.neutral['500'];
                else
                    return 'lightgray';
            } else {
                switch (points) {
                    case 4:
                        return 'limegreen';
                    case 3:
                        return 'limegreen';
                    case 2:
                        return 'orange';
                    case 1:
                        return 'red';
                    default:
                        return 'lightgray';
                }
            }
        }

        return 'lightgray';
    }, [disabled, score]);

    return (<>
        {(flags.thesisScore && !!score) && (
            <Tooltip
                placement="top-start"
                title={<Typography fontSize="0.85rem">{fitnessTip()}</Typography>}
                componentsProps={{tooltip:{sx:{
                    paddingLeft: 2, paddingRight: 2,
                    backgroundColor: 'rgba(97, 97, 97)',
                }}}}>
                <Stack direction="row" spacing="0.25rem" alignItems="center">
                    {[...Array(4)].map((_, i) => (
                        <CircleIcon
                            className={classes.scoreIcon}
                            sx={{ fill: fitnessColor(i) }}
                            key={'thesis-score-82-' + i} />
                    ))}
                </Stack>
            </Tooltip>
        )}
    </>);
}

export default withLDConsumer()(ThesisScore);